'use client'

import generateClassNames from '@/utils/generate-class-names'
import clsx from 'clsx'
import mergeRefs from 'merge-refs'
import { forwardRef, useContext } from 'react'
import { TabIndicator } from '../tab-indicator'
import { TabsContext } from '../tabs-context'
import './tab-list.scss'

const classes = generateClassNames('tab-list', [])

export interface TabListProps extends React.HTMLAttributes<HTMLDivElement> {}

export const TabList = forwardRef(function TabList(
  props: TabListProps,
  ref: React.ForwardedRef<HTMLDivElement>
) {
  const { children, className, ...other } = props

  const { tabListRef, variant } = useContext(TabsContext)

  return (
    <div
      ref={mergeRefs(tabListRef, ref)}
      role='tablist'
      className={clsx(classes.root, `${classes.root}--${variant}`, className)}
      {...other}
    >
      <TabIndicator />
      {children}
    </div>
  )
})
